<script>
export default {
    props: {
        packages: { type: Array, default: () => ({}) },
        homes: { type: Array, default: () => ([]) }
    },
    data: () => ({
        hash: '',
        activePackage: 0,
        filters: {
            interiorDesignId: 1,
        },
        sortBy: 'availability-ascending',
        limit: 4
    }),
    created() {
        this.checkForHash();
        console.log(this.packages);
    },
    computed: {
		filteredHomes() {
            return this.homes.filter(this.filterHome).sort(this.sortHome);
        },
        sort() {
            return this.sortBy ? this.sortBy.split('-')[0] : null;
        },
        sortDirection() {
            return this.sortBy ? this.sortBy.split('-')[1] : null;
        }
    },
    methods: {
        checkForHash() {
            const hash = window.location.hash;
            if (hash) {
                const activePackage = this.packages.findIndex((p) => p.slug === hash.replace('#', ''));
                if (activePackage !== -1) {
                    this.changeActivePackage(activePackage);
                }
            }
        },
        changeActivePackage(i) {
            this.activePackage = i;
            this.limit = 4;
            this.filters.interiorDesignId = this.packages[this.activePackage].id;
            window.history.replaceState({}, this.packages[this.activePackage].name, window.location.pathname + '#' + this.packages[this.activePackage].slug);
        },

		filterHome(home) {
            let passesFilter = true;

            if (this.filters.interiorDesignId && home.interior_design_id !== this.filters.interiorDesignId) {
                passesFilter = false;
            }

            return passesFilter;
        },

        sortHomeByDate(homeA, homeB, sortDirection) {
            if (!homeA.availability_date && !homeB.availability_date) {
                return 0;
            }
            if (!homeA.availability_date) {
                return 1;
            }
            if (!homeB.availability_date) {
                return -1;
            }
            return sortDirection === 'ascending'
                ? new Date(homeA.availability_date) - new Date(homeB.availability_date)
                : new Date(homeB.availability_date) - new Date(homeA.availability_date);
        },

        /**
         * Sorts 2 homes
         * @param {Object} homeA - The first home item to compare
         * @param {Object} homeB - The second home item to compare
         * @returns {Array} sorted items
         */
        sortHome(homeA, homeB) {
            const sort = this.sort;

            if(sort === 'availability') {
                return this.sortHomeByDate(homeA, homeB, this.sortDirection);
            }
            let a = homeA[sort] ? parseFloat(homeA[sort]) : 0;
            let b = homeB[sort] ? parseFloat(homeB[sort]) : 0;

            // If homes are equal, sort secondarily by price unless
            // primary sort is price
            if (sort !== 'price' && a === b) {
                a = homeA.price ? parseFloat(homeA.price) : 0;
                b = homeB.price ? parseFloat(homeB.price) : 0;
                // Secondary price sorting will always be ascending
                return a === 0 ? 1 : (b === 0 ? -1 : a - b);
            }

            // Put all 0 or empty properties last
            if (this.sortDirection === 'ascending' && a === 0) {
                return 1;
            }
            if (this.sortDirection === 'ascending' && b === 0) {
                return -1;
            }
            if (this.sortDirection === 'descending' && a === 0) {
                return -1;
            }
            if (this.sortDirection === 'descending' && b === 0) {
                return 1;
            }

            return this.sortDirection === 'ascending' ? a - b : b - a;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/interior-designs.vue